import * as React from "react";
import {Fragment, Component} from "react";
import KeySolver from "../../KeySolver";

class Summary extends Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {children} = this.props;

		const getRenderingValue = (item) => {
			if(document.querySelector(`*[data-id="${item.identifier}"]`)) {
				const el = document.querySelector(`*[data-id="${item.identifier}"]`);
				// if(!el.dataset.isradio) {
				// 	const value = el.value;
				// 	if (value !== '1') {
				// 		return `${item.properties.title}: ${value}`;
				// 	}
				// 	if (el.checked === true) {
				// 		return `${item.properties.title}`;
				// 	}
				// } else {
				// 	const els = document.querySelectorAll(`*[data-id="${item.identifier}"]`);
				// 	els.forEach((element, i) => {
				// 		const value = element.value;
				// 		if(element.checked === true) {
				// 			console.log(item.children[i].properties.title)
				// 			return `${item.children[i].properties.title}`;
				// 		}
				// 	});
				// }
				const value = el.value;
				if (value !== '1') {
					return `${item.properties.title}: ${value}`;
				}
				if (el.checked === true) {
					return `${item.properties.title}`;
				}
			}
			return false;
		}

		const getFormInput = (item) => {
			if(document.querySelector(`*[data-id="${item.identifier}"]`)) {
				const el = document.querySelector(`*[data-id="${item.identifier}"]`);
				const value = el.value;
				if(value !== '1') {
					return `<input type="hidden" name="request[properties][product][properties][${item.properties.title}]" value="${value}" />`;
				}
				if(el.checked === true) {
					return `<input type="hidden" name="request[properties][product][properties][${item.properties.title}]" value="${item.properties.title}" />`;
				}
				// if(!el.dataset.isradio) {
				// 	const value = el.value;
				// 	if(value !== '1') {
				// 		return `<input type="hidden" name="request[properties][product][properties][${item.properties.title}]" value="${value}" />`;
				// 	}
				// 	if(el.checked === true) {
				// 		return `<input type="hidden" name="request[properties][product][properties][${item.properties.title}]" value="${item.properties.title}" />`;
				// 	}
				// } else {
				// 	const els = document.querySelectorAll(`*[data-id="${item.identifier}"]`);
				// 	els.forEach((element, i) => {
				// 		const value = element.value;
				// 		if(element.checked === true) {
				// 			console.log('checked renderer')
				// 			console.log(item.children[i].properties.title)
				// 			return `<input type="hidden" name="request[properties][product][properties][${item.children[i].properties.title}]" value="${item.children[i].properties.title}" />`;
				// 		}
				// 	});
				// }
			}
			return false;
		}

		return (
			<Fragment>
				<div className="accordion" id="summaryAccordion">
					{children.map((group, i) =>
						<Fragment key={KeySolver()} >
							<div className="accordion-item">
								<h2 className="accordion-header" id={`heading${i}`} >
									<button className={`accordion-button ${i === 0 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${i}`} aria-expanded="true" aria-controls={`collapse${i}`} >
										<i className={group.properties.icon} /> {group.properties.title}
									</button>
								</h2>
								<div id={`collapse${i}`} className={`accordion-collapse collapse${i === 0 ? ' show' : ''}`} aria-labelledby={`heading${i}`} data-bs-parent="#summaryAccordion">
									<div className="accordion-body">
										<span className="d-block my-1">
											{group.children.length > 0 &&
												<Fragment>
													{group.children.map((item, k) =>
														<Fragment key={KeySolver()} >
															{getRenderingValue(item) &&
																<div className="d-block my-2">
																	{getRenderingValue(item).includes('false') ? '' : getRenderingValue(item)}
																	<div dangerouslySetInnerHTML={{__html: getFormInput(item)}} />
																</div>
															}
														</Fragment>
													)}
												</Fragment>
											}
										</span>
									</div>
								</div>
							</div>
						</Fragment>
					)}
				</div>
			</Fragment>
		);
	}
}

export default Summary;
